import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class Configuration {

    public ApiUrl = 'api/v1/';

    // Api URLs

    public forgotPassword = environment.nodeApi + '/api/v1/email/forgot-password';

    public registerAccount = environment.nodeApi + '/api/v1/email/register-account';

    public todoAssigned = environment.nodeApi + '/api/v1/email/todo-assigned';

    public todoComments = environment.nodeApi + '/api/v1/email/todo-comments';

    public scrumboardTaskAdd = environment.nodeApi + '/api/v1/email/scrumboard-task-add';

    public scrumboardTaskRemove = environment.nodeApi + '/api/v1/email/scrumboard-task-remove';

    public opportunityAssigned = environment.nodeApi + '/api/v1/email/opportunity-assigned';

    public inviteMembers = environment.nodeApi + '/api/v1/invited/invitedUser-request';

    public leaveRequest = environment.nodeApi + '/api/v1/email/leave-request';

    public leaveApprove = environment.nodeApi + '/api/v1/email/leave-approve';

    public leaveReject = environment.nodeApi + '/api/v1/email/leave-reject';

    public permissionRequest = environment.nodeApi + '/api/v1/email/permission-request';

    public permissionApprove = environment.nodeApi + '/api/v1/email/permission-approve';

    public permissionReject = environment.nodeApi + '/api/v1/email/permission-reject';

    public leaveDetails = environment.nodeApi + '/api/v1/email/leave-details';

    public createUser = environment.nodeApi + '/api/v1/external/create-user';

    public sendLeave = environment.nodeApi + '/api/v1/email/send-leave';

    public reSendInviteEmail = environment.nodeApi + '/api/v1/reInvite/reSentInvitedEmail';

    public planSubscription = environment.nodeApi + '/api/v1/session';

    public updatePlanSubscription = environment.nodeApi + '/api/v1/updatePlan';

    public planDetails = environment.nodeApi + '/api/v1/plan';

    public subscribedPlanDetails = environment.nodeApi + '/api/v1/subscription';

    public customerOnboarding = environment.nodeApi + '/api/v1/customer/customerOnBoarding-request';

    public regenerateResourceAnalyticReport = environment.nodeApi + '/api/v1/external/resource-analytics';

    public sendInterviewEmail = environment.nodeApi + '/api/v1/interviewLog/send-interview';

    public createRecursive = environment.nodeApi + '/api/v1/task/create';

    public deleteRecursiveTask = environment.nodeApi + '/api/v1/task/delete';

    public downloadTask = environment.nodeApi + '/api/v1/getAll'

}
